<template>
<div class="content-main">
    <div class="main">
        <img src="../assets/images/logo.jpg" alt="" class="logo_icon">
        <div class="right-nav">
            <div class="btns-box">
            <div class="btn-child" @click="goOtherPage">Register</div>
                <div class="btn-child" @click="goPage">Login</div>
                <!-- <div class="btn-child">SignUp</div> -->
            </div>
            <div :class="{'item':true,'active_item':item.isClik}" v-for="(item,index) in list" :key="index" @click="changeItem(item,index)">{{item.text}}</div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: "navTop",
    watch: {
        $route(to, from) {
            console.log(to.path);
        }
    },
    data() {
        return {
            list: [{
                    id: 0,
                    text: "Business area",
                    isClik: true,
                },
                //  {
                //     id: 2,
                //     text: "关于我们",
                //     isClik: false
                // }
            ]
        }
    },
    created() {
        console.log(this.$route);
        if (this.$route.path == '/') {
            this.changeItem(this.list[0], 0)
        } else if (this.$route.path == '/servesProduct') {
            this.changeItem(this.list[1], 1)
        } else if (this.$route.path == '/aboutUs') {
            this.changeItem(this.list[2], 2)
        }
    },
    methods: {
        goOtherPage(){
           window.open("https://mladm.scitcs.com/login?redirect=%2Findex")
        },
        goPage() {
            window.open("https://mladm.scitcs.com/login?redirect=%2Findex")
        },
        changeItem(item, index) {
            // this.$set(this.list, {
            //     item
            // })
            this.list.forEach((item, num) => {
                if (index == num) {
                    this.$set(this.list, index, {
                        id: item.id,
                        text: item.text,
                        isClik: true,
                    })
                } else {
                    this.$set(this.list, num, {
                        id: item.id,
                        text: item.text,
                        isClik: false,
                    })
                }
            });
            console.log(this.list, "2_____________");
            //window.location.reload();
            if (item.id == 0 && this.$route.path != '/') {
                this.$router.push('/')
            } else if (item.id == 1 && this.$route.path != '/servesProduct') {
                this.$router.push('/servesProduct')
            } else if (item.id == 2 && this.$route.path != '/aboutUs') {
                this.$router.push("/aboutUs")
            }
            //console.log(item,index)
        }
    }
}
</script>

<style lang="less" scoped>
.btns-box {
    height: 100%;
    margin-right: 30px;
    //border: 1px red solid;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .btn-child {
        cursor: pointer;
        margin: 0 10px;
        padding: 15px 25px;
        color: white;
        //border:1px red solid;
        border-radius: 5px;
        background-color: #CC1F37;
    }
}

.content-main {
    width: 100%;
    //border: 1px red solid;
    //height: 5%;
    //background-color: tan;
    display: flex;
    justify-content: center;
    align-items: center;

}

.logo_icon {
    //width: 467px;
    //width: 100%;
    height: 43px;
    padding-top: 6px;
}

.main {
    width: 100%;
    padding: 0 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px rgba(255, 255, 255, 0.1) solid;
}

.right-nav {
    display: flex;
    justify-content: space-around;
    align-items: center;

    & .item {
        margin-right: 60px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        padding: 23px 0;
        border-bottom: 4px transparent solid;
    }

    & .item:last-child {
        margin-right: 0px;
    }

    .active_item {
        //text-decoration: underline;
        border-bottom: 4px #36A9FF solid;
        //padding-bottom: 10px;

    }
}

@media (max-width: 768px) {
    .main {
        padding: 0 10px;
        .logo_icon {
            height: 25px;
        }

        .btns-box {
            margin-right: 3px;

            .btn-child {
                margin: 0 6px;
                padding: 7px 8px;
            }

        }

        .right-nav {
            .item {
                padding: 8px 0;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/navTop.vue